import { z } from 'zod';

const searchSchema = z.object({
  q: z.string().optional(),
  disabled: z.enum(['true', 'false']).optional()
});

export { searchSchema };
